import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import LogoUltimateBlack from "../../assets/images/logo-bjb-ultimate.png";
import LogoUltimateWhite from "../../assets/images/logo-bjb-ultimate-white.png";
import LogoWhite from "../../assets/images/logo-white.png";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Navlink from "./Navlink";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLocale } from "../../redux/Slice";
import { useLocation } from "react-router-dom";

import { useLogout } from "../../hooks/useApi";
import { isAuthenticated } from "../../lib/api.ts";

// import { Link } from "react-router-dom";
export default function Navbar() {
    const { t, i18n } = useTranslation();
    const navbarData = t("navbar", { returnObjects: true });
    const [navbar, setNavbar] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const { pathname } = location;
    const logoutMutation = useLogout();
    const isAuth = isAuthenticated();

    const isOpenRegistration = process.env.REACT_APP_IS_OPEN_REGISTRATION === "true";

    const onChangeLocale = (lang) => {
        i18n.changeLanguage(lang);
        dispatch(setLocale(lang));
    };

    const isAlternateNavbar = () => {
        if (pathname === '/information/rules-regulations' || pathname === '/profile') {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.scrollY > 0;
            setIsScrolled(scrolled);
        };

        window.addEventListener("scroll", handleScroll);

        // Membersihkan event listener saat komponen dibongkar
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const [showChild, setShowChild] = useState(false);

    const generateStyleEn = () => {
        if (isAlternateNavbar()) {
            if (i18n.language === "en") {
                return "bg-primary text-brandBlue";
            } else {
                return "bg-white text-black";
            }
        } else {
            if (i18n.language === "en") {
                return "bg-secondary text-white";
            } else {
                return "bg-white text-brandBlue";
            }
        }
    }

    const generateStyleId = () => {
        if (isAlternateNavbar()) {
            if (i18n.language === "id") {
                return "bg-primary text-brandBlue";
            } else {
                return "bg-white text-brandBlue";
            }
        } else {
            if (i18n.language === "id") {
                return "bg-secondary text-white";
            } else {
                return "bg-white text-brandBlue";
            }
        }
    }

    // TODO: REMOVE '/' LATER!
    const isHideMenu = () => {
        if (pathname === '/coming-soon' || pathname === '/countdown') {
            return true;
        } else {
            return false;
        }
    }

    return (
        <nav>
            <div
                className={`w-full fixed z-30 top-0 transition-all duration-500 ease-in-out text-black ${isScrolled || navbar ? "bg-black/40 max-md:bg-white md:backdrop-blur-lg" : "bg-white"
                    }`}
            >
                <div className={`hidden md:!flex container px-8 mx-auto w-full justify-between lg:w-full md:items-center items-center max-md:py-4`}>
                    <div>
                        <div className="flex items-center justify-between lg:block">
                            <a href="/" className="flex items-center">
                                {isScrolled || navbar ? <img src={LogoWhite} alt="" className="w-24 2xl:w-60 md:w-44" /> : <img src={Logo} alt="" className="w-24 2xl:w-60 md:w-44" />}
                            </a>

                            <div className="lg:hidden">
                                <button
                                    className={`p-2 ${isScrolled ? "text-brand-cream" : "text-brand-cream"
                                        } rounded-md outline-none focus:border-gray-400 focus:border`}
                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? <XMarkIcon width={24} /> : <Bars3Icon className={`${isScrolled || navbar ? 'text-white' : 'text-[#164481]'}`} width={24} />}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="flex items-center justify-between lg:block">
                            <a href="https://ultimate10kseries.com/" className="flex items-center">
                                {isScrolled || navbar ? <img src={LogoUltimateWhite} alt="" className="w-24 2xl:w-60 md:w-48" /> : <img src={LogoUltimateBlack} alt="" className="w-24 2xl:w-60 md:w-48" />}
                            </a>

                            <div className="lg:hidden">
                                <button
                                    className={`p-2 ${isScrolled ? "text-brand-cream" : "text-brand-cream"
                                        } rounded-md outline-none focus:border-gray-400 focus:border`}
                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? <XMarkIcon width={24} /> : <Bars3Icon className={`${isScrolled || navbar ? 'text-white' : 'text-[#164481]'}`} width={24} />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* mobile navbar */}
                <div className={`block md:hidden container w-full justify-between items-center max-md:pt-4`}>
                    <div className="px-8 mx-auto">
                        <div className="flex items-center justify-between lg:block">
                            <a href="/" className="flex items-center">
                                <img src={Logo} alt="" className="w-24 2xl:w-60 md:w-44" />
                            </a>

                            <a href="https://ultimate10kseries.com/" className="flex items-center">
                                <img src={LogoUltimateBlack} alt="" className="w-24 2xl:w-60 md:w-48" />
                            </a>
                        </div>
                    </div>
                    {!isHideMenu() && <div className={`bg-primary w-full transition-all duration-300 ${isScrolled || navbar ? "md:!hidden" : "md:block"}`}>
                        <div className="flex items-end justify-end mx-6">
                            <div className="lg:hidden">
                                <button
                                    className={`p-2 ${isScrolled ? "text-brand-cream" : "text-brand-cream"
                                        } rounded-md outline-none focus:border-gray-400 focus:border`}
                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? <XMarkIcon className="text-white" width={24} /> : <Bars3Icon className={`text-white`} width={24} />}
                                </button>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className={`block md:hidden px-8 mx-auto w-full justify-between items-center bg-white`}>
                    <div></div>
                    <div>
                        <div
                            className={`flex-1 w-full justify-self-end pb-2 mt-2 2xl:text-base text-sm duration-300
                    ${navbar || (window.innerWidth >= 1024)
                                    ? "block"
                                    : "hidden"
                                }
                    ${window.innerWidth >= 1024 ? "lg:!block" : "md:!block"}`}
                        >
                            <ul
                                className={`w-full items-end justify-end space-y-6 duration-300 ${isScrolled ? "text-black" : "text-black"
                                    } font-roboto antialiased text-right`}
                            >
                                <div className="flex gap-x-2 items-end justify-end">
                                    <li>
                                        <button
                                            onClick={() => onChangeLocale("en")}
                                            className={`uppercase font-bold rounded-md text-black px-3 py-1 transition-all duration-300 ${generateStyleEn()}`}
                                        >
                                            ENG
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => onChangeLocale("id")}
                                            className={`uppercase font-bold rounded-md text-black px-3 py-1 transition-all duration-300 ${generateStyleId()}`}
                                        >
                                            ID
                                        </button>
                                    </li>
                                </div>
                                {navbarData.map((value, index) => {
                                    return value.isHide === false ? (
                                        <div
                                            key={index}
                                            className="relative border-b border-brandYellow"
                                            onClick={() =>
                                                value.child ? setShowChild(!showChild) : null
                                            }
                                        >
                                            <Navlink
                                                label={value.label}
                                                href={value.href}
                                                isButton={value.isButton || false}
                                                child={value.child}
                                                isScrolled={isScrolled}
                                                navbar={navbar}
                                            />

                                            {value.child ? (
                                                <div
                                                    className={`mt-2 pb-2 ml-6 ${showChild ? "block md:hidden" : "hidden"
                                                        }`}
                                                >
                                                    <ul className="space-y-3">
                                                        {value.child.map((value, index) => {
                                                            if (value.isHide) return null;

                                                            return <li key={index + 3}>
                                                                <a href={value.href}>{value.label}</a>
                                                            </li>;
                                                        })}
                                                    </ul>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null;
                                })}
                                {isOpenRegistration && (
                                    !isAuth ? (
                                        <div className="relative border-b border-brandYellow">
                                            <a href="/login">
                                                <span className="font-roboto text-base relative group font-normal !text-black uppercase transition-all duration-300 cursor-pointer">{t("home.login")}</span>
                                            </a>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="relative border-b border-brandYellow">
                                                <a href="/profile">
                                                    <span className="font-roboto text-base relative group font-normal !text-black uppercase hover:font-semibold transition-all duration-300 cursor-pointer">{t("home.profile")}</span>
                                                </a>
                                            </div>
                                            <div className="relative border-b border-brandYellow">
                                                <span onClick={(e) => {
                                                    e.preventDefault();
                                                    logoutMutation.mutate(undefined, {
                                                        onSuccess: () => {
                                                            window.location.href = "/";
                                                        }
                                                    });
                                                }} className="font-roboto text-base relative group font-normal !text-black uppercase hover:font-semibold transition-all duration-300 cursor-pointer">{t("home.logout")}</span>
                                            </div>
                                        </>
                                    )
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* mobile navbar end */}
                {!isHideMenu() && <div className={`hidden md:!flex px-8 mx-auto w-full justify-between transition-all duration-300 lg:w-full md:items-center items-center ${isAlternateNavbar() ? 'bg-primary border-b-8 border-white' : 'bg-primary'} ${isScrolled || navbar ? "md:!hidden" : "md:block"}`}>
                    <div></div>
                    <div>
                        <div
                            className={`flex-1 justify-self-start pb-2 mt-2 2xl:text-base text-sm duration-300
                    ${navbar || (window.innerWidth >= 1024)
                                    ? "block"
                                    : "hidden"
                                }
                    ${window.innerWidth >= 1024 ? "lg:!block" : "md:!block"}`}
                        >
                            <ul
                                className={`items-center justify-center space-y-6 duration-300 !text-black"
                                    } md:flex md:space-x-8 md:space-y-0 font-roboto antialiased`}
                            >
                                {navbarData.map((value, index) => {
                                    return value.isHide === false ? (
                                        <div
                                            key={index}
                                            className="relative"
                                            onClick={() =>
                                                value.child ? setShowChild(!showChild) : null
                                            }
                                        >
                                            <Navlink
                                                label={value.label}
                                                href={value.href}
                                                isButton={value.isButton || false}
                                                child={value.child}
                                                isScrolled={isScrolled}
                                                navbar={navbar}
                                            />

                                            {value.child ? (
                                                <div
                                                    className={`mt-2 ml-6 ${showChild ? "block md:hidden" : "hidden"
                                                        }`}
                                                >
                                                    <ul className="space-y-3">
                                                        {value.child.map((value, index) => {
                                                            if (value.isHide) return null;

                                                            return <li key={index + 3}>
                                                                <a href={value.href}>{value.label}</a>
                                                            </li>;
                                                        })}
                                                    </ul>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null;
                                })}
                                {isOpenRegistration && (
                                    !isAuth ? (
                                        <div className="relative">
                                            <a href="/login">
                                                <span className={`font-roboto text-base relative group uppercase font-normal transition-all duration-300 cursor-pointer ${isAlternateNavbar() ? 'text-white' : 'text-black'}`}>{t("home.login")}</span>
                                            </a>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="relative">
                                                <a href="/profile">
                                                    <span className={`font-roboto text-base relative group font-normal uppercase hover:font-semibold transition-all duration-300 cursor-pointer ${isAlternateNavbar() ? 'text-white' : 'text-black'}`}>{t("home.profile")}</span>
                                                </a>
                                            </div>
                                            <div className="relative">
                                                <span onClick={(e) => {
                                                    e.preventDefault();
                                                    logoutMutation.mutate(undefined, {
                                                        onSuccess: () => {
                                                            window.location.href = "/";
                                                        }
                                                    });
                                                }} className="font-roboto text-base relative group font-normal !text-black uppercase hover:font-semibold transition-all duration-300 cursor-pointer">{t("home.logout")}</span>
                                            </div>
                                        </>
                                    )
                                )}
                                <div className="flex gap-x-2">
                                    <li>
                                        <button
                                            onClick={() => onChangeLocale("en")}
                                            className={`uppercase font-bold rounded-md text-black px-3 py-1 transition-all duration-300 ${generateStyleEn()}`}
                                        >
                                            ENG
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => onChangeLocale("id")}
                                            className={`uppercase font-bold rounded-md text-black px-3 py-1 transition-all duration-300 ${generateStyleId()}`}
                                        >
                                            ID
                                        </button>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>}
            </div>
        </nav>
    );
}
